import script from "./TodayArticle.vue?vue&type=script&setup=true&lang=js"
export * from "./TodayArticle.vue?vue&type=script&setup=true&lang=js"

import "./TodayArticle.vue?vue&type=style&index=0&id=347a9f28&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@5.99.5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-347a9f28"]])

export default __exports__